
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1818 21H3.81818C3.33597 21 2.87351 20.8104 2.53253 20.4728C2.19156 20.1352 2 19.6774 2 19.2V10.8V4C2 3.44771 2.44772 3 3 3H8.64338C9.02803 3 9.37858 3.22062 9.54497 3.56742L10.7278 6.03258C10.8941 6.37938 11.2447 6.6 11.6293 6.6H21C21.5523 6.6 22 7.04771 22 7.6V19.2C22 19.6774 21.8084 20.1352 21.4675 20.4728C21.1265 20.8104 20.664 21 20.1818 21ZM11 10V13.5858L9.70712 12.2929L8.29291 13.7071L12 17.4142L15.7071 13.7071L14.2929 12.2929L13 13.5858V10H11Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowAttachmentDownloadFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
